module.exports = __webpack_public_path__ + "f70a9f39b647adfe8c61d3e8b6eb5c75.svg";